<div *ngIf="errorList" class="error-snackbar">
  <ul class="error-list">
    <li *ngFor="let item of errorList">
      {{ item }}
    </li>
  </ul>
</div>
